import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'page-container',
    templateUrl: './page-container.component.html',
    styleUrls: ['./page-container.component.css'],
    standalone: false
})
export class PageContainerComponent implements OnInit {

  @Input() title: string | undefined;
  @Input() border: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

}
